export default function anonymous(context
) {
var out='';var arr1=context.courses;if(arr1){var course,index=-1,l1=arr1.length-1;while(index<l1){course=arr1[index+=1];out+='<div onclick="pricker.onSelectCourse('+( index )+')" onmousedown="return false">'+( course.print('text') )+'</div>';} } return out;
}